import { H5 } from '@fs/zion-ui'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { usePageView } from '@fs/zion-analytics'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import { usePageTitle } from '../../app/PageTitleContext'
import useAttachedArtifacts from '../../../hooks/artifacts/useAttachedArtifacts'
import { ARTIFACT_CATEGORY, DEFAULT_PAGE_SIZE } from '../../artifacts/util/artifactsConstants'
import { PersonContext } from '../PersonContext'
import ArtifactRow from './ArtifactRow'
import DmcPaginator from '../../common/DmcPaginator'

/**
 * Displays a page of memories attached to the person in the current PersonContext
 */
export default function PersonMemories() {
  usePageView({ page_detail: 'DMConsole:PersonMemories' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.person.memories'))
  const MAX_RESULTS = 500
  const { currentPerson } = useContext(PersonContext)
  const personId = currentPerson.id
  const [index, setIndex] = useState(0)
  const [pageCount, setPageCount] = useState(DEFAULT_PAGE_SIZE)
  const attachedArtifacts = useAttachedArtifacts({
    personId,
    artifactCategory: ARTIFACT_CATEGORY.ANY,
    paginatorCount: pageCount,
    firstRecord: index * pageCount,
  })
  if (!attachedArtifacts || attachedArtifacts.totalArtifactsSpanningPages === undefined) {
    return null
  }

  return (
    <>
      <H5 supplementary>
        {attachedArtifacts && attachedArtifacts.totalArtifactsSpanningPages !== 1
          ? t('artifacts.countMemoriesAttachedToPersonName_plural', '{count} Memories Attached to {personName}', {
              count: attachedArtifacts.totalArtifactsSpanningPages,
              personName: currentPerson.name,
            })
          : t('artifacts.countMemoryAttachedToPersonName', '1 Memory Attached to {personName}', {
              personName: currentPerson.name,
            })}
      </H5>
      {attachedArtifacts.totalArtifactsSpanningPages > 0 && (
        <DmcPaginator
          maxPageCount={MAX_RESULTS}
          length={attachedArtifacts.totalArtifactsSpanningPages}
          pageCount={pageCount}
          setPageCount={setPageCount}
          index={index}
          setIndex={setIndex}
        >
          <DmcResponsiveTable
            id="personMemoriesTable"
            totalColumnCount={6}
            atSizeColumns={{
              default: {
                labels: [
                  '',
                  t('title', 'Title'),
                  t('description', 'Description'),
                  t('artifacts.uploadDate', 'Upload Date'),
                  t('artifacts.artifactId', 'Artifact ID'),
                  '',
                ],
              },
            }}
          >
            {attachedArtifacts.artifacts.map((artifact) => (
              <ArtifactRow key={artifact.id} artifact={artifact} />
            ))}
          </DmcResponsiveTable>
        </DmcPaginator>
      )}
    </>
  )
}
